export const API_TIMEOUT = 15000;

export class TimeoutError extends Error {
  constructor(message: string = 'Request timeout') {
    super(message);
    this.name = 'TimeoutError';
  }
}

export const createTimeoutPromise = (
  timeoutMs: number = API_TIMEOUT
): { promise: Promise<never>; clearTimeout: () => void } => {
  let timeoutId: NodeJS.Timeout;

  const promise = new Promise<never>((_, reject) => {
    timeoutId = setTimeout(() => {
      reject(new TimeoutError(`Request timed out after ${timeoutMs}ms`));
    }, timeoutMs);
  });

  return {
    promise,
    clearTimeout: () => clearTimeout(timeoutId)
  };
};

export const withTimeout = <T>(
  promise: Promise<T>,
  timeoutMs: number = API_TIMEOUT
): Promise<T> => {
  const { promise: timeoutPromise, clearTimeout } = createTimeoutPromise(timeoutMs);

  return Promise.race([
    promise.then(result => {
      clearTimeout();
      return result;
    }),
    timeoutPromise
  ]);
};
